import React, { Component } from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import { connect } from 'react-redux';
import { RiSettings3Line } from "react-icons/ri";
import { Alert, Card, Col, Row } from 'reactstrap';
import { Spinner, Tab, Nav, Button } from 'react-bootstrap';
import General from '../../../components/Admin/config_systems/General.js';
import Mail from '../../../components/Admin/config_systems/Mail.js';
import Payment from '../../../components/Admin/config_systems/Payment.js';
import ModalComponent from  '../../../components/ModalComponent';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import LiveChatComponent from "../../../components/Admin/config_systems/LiveChatComponent";
import TelegramComponent from "../../../components/Admin/config_systems/TelegramComponent";

class ConfigSystemPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			disableButtonSave: false,
			general: {},
			mail: {},
			payment: {
				payment_amount_min: '',
				payment_amount_max: '',
				list_config_payment: [],
			},
			list_config_payment: [],
			config_bank: [],
			imagesShow: {
				website_logo: '',
				website_logo_w: '',
				website_favicon: '',
			},
			error: false,
			messageError: '',
			isNotification: '',
			textNotification: '',
			isSpinner: false,

			contentModal: '',
			isModal: false,
			isBtnConfirm: true,
			btnConfirmDisabled: false,
			alert: {
                error: false,
                message: ''
            },
            hiddenPass: true,
			passType: 'password',
            liveChat: { isLiveChat: false, liveChat: '' },
            inpLiveChat: '',
            config_telegram: {
                telegram_url: '',
                telegram_token: '',
                telegram_chat_id: '',
            },
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getConfigSystem();
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	getConfigSystem = () => {
		this.setState({
			isLoading: true
		});

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			}
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/config-system', config)
		.then( (ref) => {
			// console.log(ref.data.content.data.general);
			if ( ref.data.error === 0 ) {
				this.setState({					
					general: ref.data.content.data.general,
					mail: ref.data.content.data.mail,
					payment: ref.data.content.data.payment,
					list_config_payment: ref.data.content.data.payment.list_config_payment,
					config_bank: ref.data.content.data.config_bank,
                    liveChat: ref.data.content.data.liveChat,
                    config_telegram: ref.data.content.data.telegram,

					imagesShow: {
						...this.state.imagesShow,
						website_logo:  process.env.REACT_APP_API_URL + '/' + ref.data.content.data.general.website_logo,
						website_logo_w:  process.env.REACT_APP_API_URL + '/' + ref.data.content.data.general.website_logo_w,
						website_favicon:  process.env.REACT_APP_API_URL + '/' + ref.data.content.data.general.website_favicon,
					},
					isLoading: false,
					error: false,
					messageError: '',
				});

				let data_system = {
					website_name: ref.data.content.data.general.website_name,
                    website_phone: ref.data.content.data.general.website_phone,
                    website_title: ref.data.content.data.general.website_title,
                    email_signature: ref.data.content.data.general.email_signature,
                    website_address: ref.data.content.data.general.website_address,
                    website_company: ref.data.content.data.general.website_company,
                    website_domain: ref.data.content.data.general.website_domain,
                    website_email: ref.data.content.data.general.website_email,
                    website_facebook_url: ref.data.content.data.general.website_facebook_url,
                    website_favicon: process.env.REACT_APP_API_URL + '/' + ref.data.content.data.general.website_favicon,
                    website_logo: process.env.REACT_APP_API_URL + '/' + ref.data.content.data.general.website_logo,
                    website_logo_w: process.env.REACT_APP_API_URL + '/' + ref.data.content.data.general.website_logo_w,
                };

				this.props.updateSystem(data_system);

			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
						isLoading: false
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

	checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	handleSubmit = (e) => {
		e.preventDefault();

		this.setState({
			isLoading: true,
			isNotification: '',
			textNotification: '',
			disableButtonSave: true,
		});

		let formData = new FormData();
		const data = {...this.state.general, ...this.state.mail, ...this.state.payment,
            ...this.state.config_telegram ,...{ liveChat: this.state.inpLiveChat }};

		for (let [key, val] of Object.entries(data)) {
		  formData.append(key, val);
		}
		for (let [key, val] of Object.entries(this.state.list_config_payment)) {
		  formData.append(`list_config_payment[${key}][setting]`, val.setting);
		  formData.append(`list_config_payment[${key}][value]`, val.value);
		  formData.append(`list_config_payment[${key}][content]`, val.content);
		  formData.append(`list_config_payment[${key}][note]`, val.note);
		}

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			}
		}

		axios.post( process.env.REACT_APP_API_URL + '/api/admin/config-system', formData, config)
		.then( (ref) => {
			// console.log(ref.data);
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
                    isLoading: false,
                    error: false,
                    messageError: '',
                    disableButtonSave: false,
				});
				this.getConfigSystem();
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
                        isLoading: false,
                        disableButtonSave: false,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

	change = key => (e) => {
		if (e.target.type === 'file') {
			this.setState(
			{
				[key]: {
		            ...this.state[key],
		            [e.target.name]: e.target.files[0]
		        },
			    imagesShow: {
					...this.state.imagesShow,
					[e.target.name]: URL.createObjectURL(e.target.files[0])
				}
			})
		} else {
			this.setState({
				[key]: {
		            ...this.state[key],
		            [e.target.name]: e.target.value
		        },
			})
		}
	}

    hiddenModal = () => {
        this.setState({
            isModal: false
        })
    }

    confirmModal = () => {
    	this.setState({
    		isModal: false,
    		btnConfirmDisabled: true,
            isBtnConfirm: false,
            alert: {
                error: false,
                message: ''
            },
        	mail: {
    			...this.state.mail,
    			email_signature: this.state.email_signature_content
    		}
        })
	}

    showModal = () => {
        let titleModal = 'Thiết lập chữ ký email';
        let modalBody = this.modalBody();
        this.setState({
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false
        })
    }

    modalBody = () => {
    	return (
    		<>
    			<CKEditor
                    editor={ ClassicEditor }
                    data={this.state.mail.email_signature}
                    onChange={ ( event, editor ) => {
                        const data = editor.getData();
                        this.setState({
                        	email_signature_content: data
                        })
                    } }
                />
    		</>
    	)
    }


	tabConfig = () => {
		if (this.state.isLoading) {
			return (
				<div className="text-center">
	    			<Spinner animation="grow" variant="primary" />
	                <Spinner animation="grow" variant="secondary" />
	                <Spinner animation="grow" variant="success" />
	                <Spinner animation="grow" variant="danger" />
	                <Spinner animation="grow" variant="warning" />
	                <Spinner animation="grow" variant="info" />
	            </div>
			)
		} else {
			return (
                <Tab.Content>
	                <Tab.Pane eventKey="general">
	                	<General 
	                		general={ this.state.general } 
	                		imagesShow={ this.state.imagesShow } 
	                		onChangeValue={ this.change('general')} 
	                	/>
	                </Tab.Pane>
	                <Tab.Pane eventKey="mail">
	                	<Mail 
	                		mail={ this.state.mail } 
	                		onChangeValue={ this.change('mail')} 
	                		showModal={ this.showModal }
	                		logOut={this.props.logOut}
	                		token={this.props.token}
	                	/>
	                </Tab.Pane>
	                <Tab.Pane eventKey="payment">
	                	<Payment 
	                		payment={this.state.payment} 
	                		list_config_payment={this.state.list_config_payment} 
	                		config_bank={ this.state.config_bank } 
	                		onChangeValue={ this.change} 
	                		onChangeMethodPayment={ (name, value) => this.onChangeMethodPayment(name, value) }
	                	/>
	                </Tab.Pane>
                    {
                        this.props.telegram ? (
                            <Tab.Pane eventKey="telegram">
                                <TelegramComponent
                                    telegram={this.state.config_telegram}
                                    onChangeValue={ this.change('config_telegram') }
                                />
                            </Tab.Pane>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.live_chat ? (
                            <Tab.Pane eventKey="live_chat">
                                <LiveChatComponent
                                    liveChat={this.state.liveChat}
                                    onChangeValue={ (inpLiveChat) => this.changeLiveChat(inpLiveChat) }
                                />
                            </Tab.Pane>
                        ) : (
                            <></>
                        )
                    }
	          	</Tab.Content>
            )
		}
	}

    changeLiveChat = (inpLiveChat) => {
        this.setState({
            inpLiveChat: inpLiveChat
        })
    }

    onChangeMethodPayment = (name, value) => {
        this.setState({
            [name]: value,
            payment: {
            	...this.state.payment,
            	[name]: value
            }
        })
    }

	render() {
		return (
			<>
				<Breadcrumb title={"Config System"} page={"Config System"} icon={<RiSettings3Line className="breadcrumb-icon" />} />	
				<div className="row" style={{ marginTop: 20 }}>
                    <div className="col-md-12">
                        {
                            this.state.error ? (
                                <Alert color="danger">
                                    { this.state.messageError }
                                </Alert>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.checkNotification()
                        }
                    </div>
                </div>
                <Card body>
                	<form onSubmit={ this.handleSubmit }>
                		<div className="row" id="config-system">
                			<div className="col-12">

                				<Tab.Container defaultActiveKey="general">
					              	<Row>
						                <Col sm={12} className="pb-3 mb-3" style={{ borderBottom: 'solid #dbdada 1px' }} >
						                  	<Nav variant="pills">
							                    <Nav.Item>
							                      <Nav.Link eventKey="general" className="nav-pills-sm">Cài đặt chung</Nav.Link>
							                    </Nav.Item>

							                    <Nav.Item>
							                      <Nav.Link eventKey="mail" className="nav-pills-sm">Mail</Nav.Link>
							                    </Nav.Item>

							                    <Nav.Item>
							                      	<Nav.Link eventKey="payment" className="nav-pills-sm">Thanh toán</Nav.Link>
						                    	</Nav.Item>
                                                {
                                                    this.props.telegram ? (
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="telegram" className="nav-pills-sm">Thông báo Telegram</Nav.Link>
                                                        </Nav.Item>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                {
                                                    this.props.live_chat ? (
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="live_chat" className="nav-pills-sm">Live Chat</Nav.Link>
                                                        </Nav.Item>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
						                  	</Nav>
						                </Col>

						                <Col sm={12}>
						                	{
						                		this.tabConfig()
						                	}
						                </Col>
					              	</Row>
					            </Tab.Container>

                			</div>
	            		</div>
	            		<Row>
	            			<Col className="text-right mb-0 mt-4">
	            				<Button 
	            					type="submit"
	            					variant="primary" 
									disabled={this.state.disableButtonSave}
									onClick={ this.testSendMail }
								>
									Lưu
							  	</Button>
	            			</Col>
	            		</Row>
	            	</form>
                </Card>

                <ModalComponent
                	className="modal-lg"
                    isModal={ this.state.isModal }
                    content={this.state.contentModal}
                    isBtnConfirm={ this.state.isBtnConfirm }
                    btnConfirmDisabled={ this.state.btnConfirmDisabled }
                    hiddenModal={ () => this.hiddenModal() }
                    confirmModal={ () => this.confirmModal() }
                    alert={ this.state.alert }
                />

			</>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
        live_chat: state.configSystem.live_chat,
        telegram: state.configSystem.telegram,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminConfigSystem' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
        updateSystem: (item) => {
            dispatch(({type: 'updateSystem', item}))
        },
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigSystemPage);